import EventSidebar from './sidebar/Event/EventSidebar';
import EventContent from './main-content/manage-event/EventContent';
import useEventDashboard from './user-dashboard/useEventDashboard';
import EventDashboardSkeleton from '../../components/skeleton/EventDashboardSkeleton';
import NotFound from '../../pages/404/NotFound';
import '../../styles/components/Dashboard.css';

function Dashboard() {
    const { loading, isEventFound, isEventFetchProcessComplete, isNewEvent } = useEventDashboard();

    if (loading) {
        return <EventDashboardSkeleton />;
    }

    const showNotFound = !loading && isEventFetchProcessComplete && !isEventFound && !isNewEvent;

    // If user does not have access or event is not found, show NotFound page
    if (showNotFound) {
        return (
            <NotFound
                pageTitle="Event Not Found"
                description="The event you are looking for does not exist or you do not have access to it."
            />
        );
    }

    return (
        <div className="main-platform-dashboard">
            <div className="main-dashboard-container">
                <div className="dashboard-content">
                    <div className="dashboard-sidebar-container">
                        <div className="sidebar-dashboard-navigation-container">
                            <EventSidebar />
                        </div>
                    </div>

                    <div className="dashboard-sidebar-content-area">
                        <div className="main-dashboard-content-area">
                            <div className="centered-main-content">
                                <EventContent />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
